import { useRecoilValueLoadable } from "recoil";
import { userAtom } from "@state/State";
import _ from "lodash";

export const useLoggedIn = (): boolean => {
  const user = useRecoilValueLoadable(userAtom);
  return user.state === "hasValue" && !_.isEmpty(user.contents);
};
